import { EnvironmentContext } from "components/Environment/EnvironmentContext";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import useTypedContext from "hooks/useTypedContext";
import DownloadFileButton from "views/Account/Context/MountedFiles/ListItem/Download";

import { showMountedFilesFormDrawer } from "../../MountedFileDrawer/MountedFilesFormDrawer";
import { showDeleteConfirmation } from "../../VariableDeleteConfirmation/VariableDeleteConfirmation";
import EnvironmentTableCell from "../Cell";
import { EnvironmentVariableCellProps } from "./types";

const MountedFilesActionsCell = ({ item, ...cellProps }: EnvironmentVariableCellProps) => {
  const { onDelete, onUpdate, canDeleteVariables, canCreateAndEditVariables } =
    useTypedContext(EnvironmentContext);

  const file = item.element;
  const canBeEdited = !(file.runtime || item.context);

  const hasEditAction =
    canBeEdited && (canCreateAndEditVariables.result || !!canCreateAndEditVariables.message);
  const hasOverrideAction =
    !canBeEdited && (canCreateAndEditVariables.result || !!canCreateAndEditVariables.message);
  const hasDeleteAction =
    canBeEdited && (canDeleteVariables.result || !!canDeleteVariables.message);

  const hasAnyAction = hasEditAction || hasOverrideAction || hasDeleteAction;
  const hasDownloadAction = !file.writeOnly && !!file.value;

  return (
    <EnvironmentTableCell {...cellProps}>
      {hasAnyAction && (
        <DropdownMenuEllipsis tooltip="Environment variable actions">
          {hasEditAction && (
            <DropdownMenuItem
              isDisabled={!canCreateAndEditVariables.result}
              tooltip={canCreateAndEditVariables.message}
              onAction={() => showMountedFilesFormDrawer({ id: file.id, onSubmit: onUpdate, file })}
            >
              Edit file
            </DropdownMenuItem>
          )}
          {hasOverrideAction && (
            <DropdownMenuItem
              isDisabled={!canCreateAndEditVariables.result}
              tooltip={canCreateAndEditVariables.message}
              onAction={() => showMountedFilesFormDrawer({ id: file.id, onSubmit: onUpdate, file })}
            >
              Override
            </DropdownMenuItem>
          )}
          {(hasEditAction || hasOverrideAction) && hasDownloadAction && (
            <DownloadFileButton fileName={file.id} href={file.value ?? ""} />
          )}
          {hasDeleteAction && (
            <DropdownMenuItem
              isDisabled={!canDeleteVariables.result}
              tooltip={canDeleteVariables.message}
              onAction={() => showDeleteConfirmation({ id: file.id, onDelete })}
              danger
            >
              Delete
            </DropdownMenuItem>
          )}
        </DropdownMenuEllipsis>
      )}
    </EnvironmentTableCell>
  );
};

export default MountedFilesActionsCell;
